<template>
  <v-row class="ma-4 mpc-gpu mx-auto">
    <v-col class="pa-0">
      <v-img src="@/assets/illustrations/gpu.svg" height="44px" width="48px" class="mx-auto"/>
      <div class="token-text-h4 mb-2 text-center">
        GPU nodes
      </div>
      <div class="token-text-regular mb-6 text-center">
        Do you need to run AI workloads?
      </div>
      <div class="card">
        <CustomButton
          class="full-width mb-2"
          :level="$enums.ButtonLevels.Secondary"
          @click="$emit('update:requireGPU', true)"
        >
          Yes
        </CustomButton>
        <CustomButton
          class="full-width mb-2"
          :level="$enums.ButtonLevels.Secondary"
          @click="$emit('update:requireGPU', false)"
        >
          No
        </CustomButton>
      </div>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { Vue, Options, prop } from 'vue-class-component'

import CustomButton from '@/components/UIElements/CustomButton.vue'

class Props {
  requireGPU: boolean = prop({
    required: true,
  });
}


@Options({
  components: {
    CustomButton
  },
})
export default class MPCGPU extends Vue.with(Props) {


}
</script>
<style lang="scss" scoped >
@import '@/css/variables';
.mpc-gpu {
  width: calc(100% - 16px);
}
</style>